import DeveloperView from './DeveloperView';

export default DeveloperView;
